import Observer, { TObserverCallback } from "./Observer"

export default class Debounce<T> extends Observer<T> {
    private _delay : number
    private _timeout : any
    private _callback : (val:T)=>void

    constructor(delay:number){
        super()
        this._delay = delay
        this._callback = this.callback.bind(this)
    }

    unsubscribe(cb:TObserverCallback<T>){
        super.unsubscribe(cb)
        this.subscribers.length==0 && this.cancel()
        return this
    }

    cancel(){
        if (this._timeout) {
            clearTimeout(this._timeout)
            this._timeout = null
        }
    }

    next(arg:T) {
        super.next(arg)
        this.cancel()
        this._timeout = setTimeout(this._callback, this._delay)
    }
}